import crypto from "crypto";

export const getCryptoRandomString = len =>
  crypto
    .randomBytes(Math.ceil(len / 2))
    .toString("hex")
    .slice(0, len);



// WEBPACK FOOTER //
// ./src/utils/CryptoRandomString.js